import React, { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  calcular?: (novoValor: number) => void;
};

export const VFieldMoneynumber4: React.FC<TVTextFieldProps> = ({ calcular, name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

  const [value, setValue] = useState<string>(() => {
    if (defaultValue == null || defaultValue === '') return '';
    return formatToMoney(String(defaultValue));
  });

  useEffect(() => {
    registerField({
      name: fieldName,

      // Aqui enviamos NUMBER para o formulário (sempre com até 4 casas)
      getValue: () => formatToNumber(value),

      setValue: (_, newValue: string | number) => {
        if (newValue === null || newValue === undefined || newValue === '') {
          setValue('');
          return;
        }
      
        setValue(formatToMoney(newValue));
      },
      
      clearValue: () => {
        setValue('');
      },
    });
  }, [registerField, fieldName, value]);

  // ---- CONVERTE STRING EM NUMBER (respeitando vírgula) ----
  const formatToNumber = (val: string): number => {
    if (!val) return 0;

    const clean = val
      .replace(/\./g, '')  // tira pontos de milhar
      .replace(',', '.');  // vírgula → ponto

    const num = Number(clean);
    if (isNaN(num)) return 0;

    // Garante no máximo 4 casas
    return Number(num.toFixed(4));
  };

  // ---- FORMATA UM VALOR (string ou number) PARA 4 CASAS, EM PT-BR ----
 const formatToMoney = (val: string | number): string => {
  if (val === '' || val === null || val === undefined) return '';

  let num: number;

  // 🔥 se já vier number, NÃO mexe
  if (typeof val === 'number') {
    num = val;
  } else {
    // string digitada pelo usuário
    const clean = val
      .replace(/\./g, '')   // remove milhar
      .replace(',', '.');   // vírgula → ponto

    num = Number(clean);
  }

  if (isNaN(num)) num = 0;

  return num.toLocaleString('pt-BR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;

    // Formata o que o usuário digita
    const formatted = formatToMoney(raw);
    setValue(formatted);

    const numberValue = formatToNumber(formatted);

    calcular?.(numberValue);

    rest.onChange?.(e);
  };

  return (
    <TextField
      {...rest}
      name={name}
      error={!!error}
      helperText={error}
      value={value}
      onChange={handleChange}
      onKeyDown={(e) => {
        if (error) clearError();
        rest.onKeyDown?.(e);
      }}
    />
  );
};
